/**
 * Refrigerator lifespan answer (FRIDGE-902).
 *
 * ONE sentence, quoted by the /tools/refrigerator-lifespan-calculator hero,
 * its first FAQ card and its FAQPage node. It cites the ENERGY STAR planning
 * assumption and says what it is not: lifespan cannot come from catalog or
 * price data, and the calculator predicts nothing.
 */
export const REFRIGERATOR_LIFESPAN_QUESTION = 'How long does a refrigerator last?'

/** The refrigerator lifetime ENERGY STAR's savings comparison assumes, in years. */
export const ENERGY_STAR_PLANNING_LIFETIME_YEARS = 12

export function refrigeratorLifespanAnswer(): string {
  return `ENERGY STAR uses a ${ENERGY_STAR_PLANNING_LIFETIME_YEARS}-year refrigerator lifetime in its savings comparison; that is a planning assumption, not a prediction of when your refrigerator will fail.`
}

export function refrigeratorLifespanAnswerFaq(): { question: string; answer: string } {
  return { question: REFRIGERATOR_LIFESPAN_QUESTION, answer: refrigeratorLifespanAnswer() }
}
